/* istanbul ignore file */
import { ArticleStatus } from 'src/app/content-management/shared/enums/article-status';
import { ContentType } from 'src/app/content-management/shared/enums/content-type';
import { IAssetClass } from '../models/i-asset-class';
import { IAuthor } from '../models/i-author';
import { ICompany } from '../models/i-company';
import { IEtf } from '../models/i-etf';
import { IFund } from '../models/i-fund';
import { IInvestmentTrust } from '../models/i-investment-trust';
import { IManager } from '../models/i-manager';
import { IPerson } from '../models/i-person';
import { ISector } from '../models/i-sector';
import { IShare } from '../models/i-share';
import { ITag } from '../models/i-tag';
import { ITopic } from '../models/i-topic';
import { IDigitalPublicationContentDto } from './interfaces/i-digital-publication-content-dto';
import { IDigitalPublicationSection } from './interfaces/i-digital-publication-section';
import { IDynamicData } from './interfaces/i-dynamic-data';
import { ContentStatus } from 'src/app/shared/enums/content-status';

export class DigitalPublicationContentDto
  implements IDigitalPublicationContentDto
{
  id?: string;
  contentId?: string;
  cas?: string;
  type?: string;
  contentType?: ContentType;
  headline?: string;
  status?: ContentStatus;
  authors?: IAuthor[];
  relatedManagers?: IManager[];
  relatedAssetClasses?: IAssetClass[];
  relatedSectors?: ISector[];
  relatedFunds?: IFund[];
  relatedEtfs?: IEtf[];
  relatedInvestmentTrusts?: IInvestmentTrust[];
  relatedShares?: IShare[];
  relatedCompanies: ICompany[];
  relatedPeople: IPerson[];
  tags: ITag[];
  topics: ITopic[];
  sections: IDigitalPublicationSection[];
  url: string;
  platform: string;
  product: string;
  client: string;
  timezoneIdentifier?: string;
  lastUpdatedDate?: Date;
  lastUpdatedByUser?: string;
  createdDate?: Date;
  publishedDate?: Date;
  presetPublishDate?: Date;
  dynamicData?: IDynamicData;
  isSpiked?: boolean;
  isPublished?: () => boolean;
  isCurrentLiveVersion?: () => boolean;

  constructor({
    id,
    contentId,
    cas,
    type,
    contentType,
    headline,
    status,
    authors,
    relatedManagers,
    relatedAssetClasses: relatedAssetClass,
    relatedSectors,
    relatedFunds,
    relatedEtfs,
    relatedInvestmentTrusts,
    relatedShares,
    relatedCompanies,
    relatedPeople: relatedPeoples,
    tags,
    topics,
    sections,
    url,
    platform,
    product,
    client,
    timezoneIdentifier,
    lastUpdatedDate,
    lastUpdatedByUser,
    createdDate,
    publishedDate,
    presetPublishDate,
    dynamicData,
    isSpiked,
  }: IDigitalPublicationContentDto) {
    this.id = id;
    this.contentId = contentId;
    this.cas = cas;
    this.type = type;
    this.contentType = contentType;
    this.headline = headline;
    this.status = status;
    this.authors = authors ?? [];
    this.relatedManagers = relatedManagers ?? [];
    this.relatedAssetClasses = relatedAssetClass ?? [];
    this.relatedSectors = relatedSectors ?? [];
    this.relatedFunds = relatedFunds ?? [];
    this.relatedEtfs = relatedEtfs ?? [];
    this.relatedInvestmentTrusts = relatedInvestmentTrusts ?? [];
    this.relatedShares = relatedShares ?? [];
    this.relatedCompanies = relatedCompanies ?? [];
    this.relatedPeople = relatedPeoples ?? [];
    this.tags = tags ?? [];
    this.topics = topics ?? [];
    this.sections = sections ?? [];
    this.url = url;
    this.platform = platform;
    this.product = product;
    this.client = client;
    this.timezoneIdentifier = timezoneIdentifier;
    this.lastUpdatedDate = lastUpdatedDate;
    this.lastUpdatedByUser = lastUpdatedByUser;
    this.createdDate = createdDate;
    this.publishedDate = publishedDate;
    this.presetPublishDate = presetPublishDate;
    this.dynamicData = { ...dynamicData };
    this.isSpiked = isSpiked;
    this.isPublished = () => this.status === ContentStatus.PUBLISHED;
    this.isCurrentLiveVersion = () =>
      this.id === this.dynamicData?.latestPublishedVersionId;
  }
}
